export { default } from './getAreasList'
export * from './getAreasList'
